import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	deprecatedIntegrationsTableIntegrationNameHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-table-integration-name-head-non-final',
		defaultMessage: 'Integration',
		description: 'Transition home deprecated integrations step table integration name head',
	},
	deprecatedIntegrationsProductNameHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-product-name-head-non-final',
		defaultMessage: 'Product',
		description: 'Transition home deprecated integrations step table product name head',
	},
	deprecatedIntegrationsTeamNameHeadNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-team-name-head-non-final',
		defaultMessage: 'Team',
		description: 'Transition home deprecated integrations step table team name head',
	},
	deprecatedIntegrationCountNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integration-count-non-final',
		defaultMessage:
			'{count, plural, one {{count} integration} other {{count} integrations}} were left behind in Opsgenie:',
		description: 'Transition home deprecated integrations count',
	},
});
